// components/dashboard/ManageListings.styles.js

// Centralized sx style tokens for ManageListings
// Import these and apply as: sx={styles.container} or sx={styles.table.root}, etc.

const styles = {
    container: {
      width: "100%",
      mx: "auto",
      px: { xs: 0, sm: 1 },
    },
  
    headerTitle: { 
      mb: 1, 
      fontWeight: 700,
      fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
    },
  
    headerBar: {
      mb: { xs: 1.5, sm: 2 },
      gap: { xs: 1, sm: 1.5 },
    },
  
    toolbar: {
      px: 2,
      py: 1,
      mb: 2,
      borderRadius: 2,
      boxShadow: 1,
      bgcolor: "background.paper",
      border: (t) => `1px solid ${t.palette.divider}`,
    },
  
    table: {
      root: {
        borderRadius: 2,
        overflow: "hidden",
        "& .MuiTableCell-root": { 
          borderBottomStyle: "dashed",
          padding: { xs: "8px 4px", sm: "12px 8px", md: "16px" },
          fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
        },
        "& .MuiTableHead-root .MuiTableCell-root": {
          fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.875rem" },
          fontWeight: 600,
        },
      },
      selectedRow: {
        "&.Mui-selected": {
          bgcolor: (t) =>
            t.palette.mode === "light"
              ? "rgba(25, 210, 133, 0.08)"
              : "rgba(39, 233, 13, 0.16)",
        },
      },
      image: {
        width: { xs: 60, sm: 70, md: 80 },
        height: { xs: 60, sm: 70, md: 80 },
        objectFit: "cover",
        borderRadius: 1,
        flexShrink: 0,
      },
    },
  
    // Mobile card layout (xs–sm)
    card: {
      root: {
        display: "flex",
        flexDirection: "column",
        gap: { xs: 1, sm: 1.5 },
        p: { xs: 1.25, sm: 1.5 },
        borderRadius: 2,
        border: (t) => `1px solid ${t.palette.divider}`,
        bgcolor: "background.paper",
        width: "100%",
        boxSizing: "border-box",
      },
      image: {
        width: 80,
        height: 80,
        objectFit: "cover",
        borderRadius: 1,
      },
      titleRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        mb: 0.5,
        minWidth: 0,
      },
      idText: {
        display: "block",
        color: "text.secondary",
        mb: 0.5,
      },
      actionsRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        mt: 1,
      },
    },
  
    paginationBox: { 
      display: "flex", 
      justifyContent: "center", 
      mt: { xs: 1.5, sm: 2 },
      "& .MuiPagination-root": {
        "& .MuiPaginationItem-root": {
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
          minHeight: { xs: 32, sm: 40 },
          minWidth: { xs: 32, sm: 40 },
        },
      },
    },
  
    // Dialog / Payment
    dialogPaper: { borderRadius: 3 },
  
    // Utility
    srOnly: {
      position: "absolute",
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0,0,0,0)",
      whiteSpace: "nowrap",
      border: 0,
    },
  };
  
  export default styles;
  